import React from 'react';
import "./Footer.css"

const Footer = () => {

    return (
        <div className="footer text-center">
            <h6>All rights reserved by Fashion-Fare</h6>
        </div>
    );
};

export default Footer;